<template>
	<transition name="video-fade" appear>
		<div ref="container" class="video-player-container" v-if="visible">
			<base-button-rounded icon="e-remove-3" :color="false ? 'var(--color-dark-gold)' : 'var(--color-gold)'" icon-color="var(--color-black)" class="exit-video" @button-clicked="exitModal" />
			<video ref="video" class="video-player" autoplay controls playsinline preload="none" >
				<source v-for="source in sources.filter(s => s.url)" :src="source.url" :type="source.type">
				<!-- 	<track
						v-if="subsVideo"
				    label="Italian"
				    kind="subtitles"
				    srclang="en"
				    :src="subsVideo"
				    default
				   /> -->
			</video>
<!-- 			<Transition name="opacity-appear">
				<base-button 
					v-if="tracksList.length && showSubsBtn" 
					class="video-subs-dropdown" 
					:text="utils.capitalizeFirst($t('scrolly_button_video_subs'))" 
					icon="arrow-sm-down-1"
					icon-active="arrow-sm-up-1"
					icon-color-param="var(--color-white)"
					:dropdown-list="tracksList" 
					@option-selected="selectSubs" 
				/>
			</Transition> -->
		</div>
	</transition>
</template>

<script type="text/javascript">

import cloneDeep from 'lodash.clonedeep';
import utils from '@js/utils.js';
import { mapGetters } from 'vuex';
import { nextTick } from 'vue';

export default {
	name: 'InterfaceVideoPlayer',
	props: {
		visible: {
			type: Boolean,
			default: false
		},
		sources: {
			type: Array,
			default: []
		},
		subsVideo: {
			type: Array,
			default: []
		}
	},
	data() {
		return {
			scrollPosition: 0,
			videoBuilt: false,
			utils,
			showSubsBtn: false
		}
	},
	computed: {
		...mapGetters(['isMobile']),
		tracksList() {
			let rtn = []
			if(this.$el && this.videoBuilt) {
				if(this.subsVideo.length) {
					rtn = Array.from(this.$el.querySelector('video').textTracks)
				}
			}
			return rtn
		}
	},
	watch: {
		async visible(n, o) {
			if(n && !o) {

				await nextTick();

				this.videoBuilt = true;

				this.$el.querySelector('video').play();

				if(this.isMobile) this.scrollPosition = document.documentElement.scrollTop

				this.$el.addEventListener('click', this.localStopPropagation, {passive: false})
				this.$el.addEventListener('wheel', this.localStopPropagation, {passive: false})

				if(this.subsVideo.length) {

					Array.from(this.$el.querySelector('video').querySelectorAll('track')).forEach(t => t.remove())

					this.subsVideo.forEach(sub => {
						var track = document.createElement("track");
						track.mode = "showing";
						track.label = sub.lang == 'en' ? "English" : "Italian";
						track.setAttribute('data-lang', sub.lang)
						track.kind = "subtitles";
						track.srclang = sub.lang;
						// track.src = this.subsVideo;
						// track.default = true;
						this.$el.querySelector('video').appendChild(track);

						utils.loadTrackWithAjax(track, sub.url)
					})
					await new Promise(resolve => setTimeout(resolve, 1));

					// if(this.subsVideo.length > 1) {
					// 	Array.from(this.$el.querySelectorAll('track')).forEach(t => t.removeAttribute('default'))
					// 	Array.from(this.$el.querySelectorAll('track')).forEach(t => {
					// 		if(t.getAttribute('data-lang') == this.$i18n.locale) {
					// 			// t.default = true;
					// 		}
					// 	})
					// }
					this.selectSubs({language: this.$i18n.locale})
				}

			}

			if(!n && o) {
				if(this.isMobile) document.documentElement.scrollTop = this.scrollPosition;

				this.$el.removeEventListener('click', this.localStopPropagation, {passive: false})
				this.$el.removeEventListener('wheel', this.localStopPropagation, {passive: false})
			}
			// this.videoSubsButtonListener();
		}
	},
	methods: {
		exitModal() {
			this.$el.querySelector('video').pause();
			this.$emit('close-video')
			this.videoBuilt = false;
		},
		localStopPropagation(e) {
			e.stopPropagation();
			e.preventDefault();
			// this.$el.addEventListener('click', utils.stopPropagation, {passive: false})
			// this.$el.addEventListener('wheel', utils.stopPropagation, {passive: false})
		},
		selectSubs(track) {
			let tracks = this.$el.querySelector('video').textTracks
			Array.from(this.$el.querySelectorAll('video tracks')).forEach(el => el.default = false)
			console.log('language from track', tracks[0].language, tracks[1].language)
			this.$el.querySelector('video').textTracks[0].mode = 'disabled'
			this.$el.querySelector('video').textTracks[1].mode = 'disabled'
			if(tracks[0].language == track.language) {
				console.log('here')
				this.$el.querySelector('video').textTracks[0].mode = 'showing'
				this.$el.querySelector('video').textTracks[1].mode = 'disabled'
			}else {
				console.log('hore')
				this.$el.querySelector('video').textTracks[0].mode = 'disabled'
				this.$el.querySelector('video').textTracks[1].mode = 'showing'				
			}
			// let selected = tracks.find(t => t.language == track.language)
			// let other = tracks.find(t => t.language !== track.language)
			// console.log('selected and other', selected, other)
			// selected.mode = 'showing'
			// other.mode = 'disabled'
		},
		videoSubsButtonListener() {
			let timeout = null;
			let fun = () => {
				console.log('mouseover video')
				// this.$el.querySelector('.video-subs-dropdown').style.display = 'block';
				this.showSubsBtn = true
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					this.showSubsBtn = false;
				}, 3000)
			};

			this.$el.querySelector('video').removeEventListener('mousemove',fun)
			this.$el.querySelector('video').addEventListener('mousemove',fun)
		}
	},
	// async updated() {
	// 	if (this.visible) {

	// 		console.log('here')
	// 		this.$el.querySelector('video').play();
	// 	}
	// },
}

</script>

<style lang="scss">

	@import '@css/variables.scss';

	.video-player-container {
		position: absolute;
		width: calc(100vw - var(--menu-size));
		height: 100%;
		left: var(--menu-size);
		top: 0;
		background-color: var(--color-black);
		overflow: hidden;
		
		opacity: 1;
		transition: opacity 0.5s;
	}
	
	.video-player-container.video-fade-enter-from,
	.video-player-container.video-fade-leave-to {
		opacity: 0;
	}

	.video-player-container .video-player  {
		width: 100%;
		height: 100%;
		object-fit: cover;
		z-index: 1;
		overflow: hidden;
		
		opacity: 1;
		transition: opacity 0.5s 0.5s;
	}
	
	/*
	.video-player-container.video-fade-enter-from .video-player,
	.video-player-container.video-fade-leave-to .video-player {
		opacity: 0;
	}
	*/

	.exit-video {
		position: fixed;
		right: 4.5rem;
		top: 4.5rem;
		z-index: 6;
	}

	.exit-video .svg-icon {
		width: 1.375rem;
		height: 1.375rem;
	}

	.video-subs-dropdown {
		position: absolute;
		top: 0;
		left: 0;
		transform: translate(3.5rem, 4.5rem);
	}

	@media (max-width: $breakpoint-sm) {
		.video-player-container {
			position: fixed;
			overflow-y: scroll;
			width: 100vw;
			height: calc(100vh - var(--menu-size));
			top: var(--menu-size);
			left: 0;
			padding: 0 1.25rem;
			z-index: 5;
		}

		.video-player-container .video-player {
			// margin: 7rem 0 2rem 0;
			width: 100vw;
			object-fit: contain;
		}

		.in-depth-title .svg-icon {
			height: 4.5rem;
		}

		.video-player {
			// margin-top: 7.125rem;
			// gap: 3.75rem;
			width: 100vw;
			height: calc(100vh - var(--menu-size));
			position: absolute;
			top: 0;
			left: 0;
			margin: 0;
			object-fit: contain;
		}

		.exit-video {
			right: 1.25rem;
			top: calc(var(--menu-size) + 1.8rem);
		}

		.exit-video .svg-icon {
			width: var(--s2);
			height: var(--s2);
		}

		.in-depth-text-content {
			line-height: 1.75rem;
		}

		.in-depth-title-content {
			font-size: 1.375rem;
		}

		.in-depth-subtitle-content {
			font-size: 1rem;
		}
	}


</style>
